/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (
  state = {
    global: {},
    staffNo: [],
    lang: "enUS",
    device: { size: "desktop", view: "container-best" },
  },
  action
) => {
  let newState = state;
  switch (action.type) {
    case "LOGIN-SUCCESS": {
      const { staffNo } = action.payload.value;
      newState = Object.assign({}, newState, { staffNo: staffNo });
      break;
    }
    case "SET-DEVICE": {
      const { size, view } = action.payload;
      if (size)
        newState = Object.assign({}, newState, {
          device: { ...newState.device, size: size },
        });
      if (view)
        newState = Object.assign({}, newState, {
          device: { ...newState.device, view: view },
        });
      break;
    }
    case "GET-GLOBAL-VAR": {
      const global = action.payload.value;
      newState = Object.assign({}, newState, { global: global });
      break;
    }
    case "LOGOUT-SUCCESS":
      newState = Object.assign({}, newState, { staffNo: [], lang: "enUS" });
      break;
    case "LOGIN-ERROR":
    case "AUTHENTICATE-ERROR":
      newState = Object.assign({}, newState, { staffNo: [] });
      break;
    case "SWITCH-LANG":
      newState = Object.assign({}, newState, { lang: action.payload });
      break;
    default:
      newState = state;
      break;
  }
  return newState;
};
